"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));

var _Reset = _interopRequireDefault(require("../Reset"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UIWrapper = function UIWrapper(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      reset = _ref.reset,
      resetClassName = _ref.className,
      resetStyles = _ref.styles;
  return (0, _core.jsx)(_ThemeProvider["default"], {
    theme: theme
  }, reset ? (0, _core.jsx)(_Reset["default"], {
    className: resetClassName,
    styles: resetStyles
  }, children) : children);
};

UIWrapper.propTypes = {
  children: _propTypes["default"].element.isRequired,
  theme: _propTypes["default"].shape({}),
  reset: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  styles: _propTypes["default"].shape({})
};
UIWrapper.defaultProps = {
  theme: {},
  reset: true,
  className: '',
  styles: null
};
UIWrapper.displayName = 'UIWrapper';
var _default = UIWrapper;
exports["default"] = _default;